var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInformation = function SvgInformation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "information_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 500 500"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".information_svg__st1{fill:#0054a6}")), /*#__PURE__*/React.createElement("path", {
    d: "M-1.2-.2h500.3v500.5H-1.2z",
    style: {
      fill: "#fd0"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M218.9 306.1q.75-3.6 2.4-9.3l14.3-52.4c.1-.6.3-1.2.4-1.8s.2-1.1.2-1.7c0-3.1-1-5.1-3-5.8s-5.6-1.2-10.8-1.5v-6.1c4.4-.3 10.7-.9 19.1-1.9q12.45-1.5 17.7-2.4l10-1.9-18.2 66.2c-1.5 5.7-2.5 9.6-3.1 11.8-1.3 5.6-2 9.3-2 10.9s.4 2.8 1.1 3.2c.7.5 1.6.7 2.5.7 2.4 0 5.3-2 8.8-6 3.4-3.9 6.5-8.2 9.3-12.6l5.1 3.3q-11.4 16.8-17.4 22.5c-6.6 6.4-13.7 9.6-21.2 9.6-4.2 0-8.2-1.4-11.5-3.9q-5.1-3.9-5.1-12c.2-2.9.6-5.9 1.4-8.9m54.9-132.5c3 2.9 4.6 6.9 4.5 11.1.1 4.2-1.6 8.2-4.5 11.1-2.9 3-6.9 4.7-11 4.6-8.7 0-15.7-7.1-15.7-15.7-.1-4.2 1.6-8.2 4.6-11.1 2.9-3 6.9-4.6 11.1-4.6 4.1 0 8.1 1.6 11 4.6",
    className: "information_svg__st1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M247.9 114.2c75 0 135.9 60.9 135.9 135.9S322.9 386 247.9 385.9c-75 0-135.9-60.8-135.9-135.9 0-75 60.9-135.8 135.9-135.8m0-16C164 98.2 96 166.2 96 250.1S164 402 247.9 402s151.9-68 151.9-151.9c0-40.3-16-78.9-44.5-107.4-28.4-28.6-67.1-44.6-107.4-44.5",
    className: "information_svg__st1"
  })));
};
export default SvgInformation;